import React, { useState, useEffect, useRef } from 'react';
import { FaBell, FaBirthdayCake } from 'react-icons/fa';
import { WhatsappIcon } from 'react-share';
import '../pages/Home.css'

import img from '../assets/images/b1.jpeg';
import imgA from '../assets/images/b2.jpeg';
import imgB from '../assets/images/b3.jpeg';
import imgC from '../assets/images/b4.jpeg';
import imgD from '../assets/images/b5.jpeg';
import imgE from '../assets/images/b6.jpeg';
import imgF from '../assets/images/b7.jpeg';
import imgG from '../assets/images/b8.jpeg';
import imgH from '../assets/images/b9.jpeg';
import imgI from '../assets/images/b10.jpeg';
import spinner from '../assets/images/loading2.gif';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import SchoolDataCard from './SchoolDataCard';

const Home = () => {
  const [todaysBirthdays, setTodaysBirthdays] = useState([]);
  const [fetchError, setFetchError] = useState(null);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [imageIndex, setImageIndex] = useState(0);
  const [selectedStudentImages, setSelectedStudentImages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [udiseNumber, setUdiseNumber] = useState('');

  useEffect(() => {
    const schoolUdiseNumber = localStorage.getItem('udiseNumber');
    if (schoolUdiseNumber) {
      setUdiseNumber(schoolUdiseNumber);
    }
  }, []);

  
  const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1); // Use your actual DB name and version

      request.onerror = (event) => {
        console.error("IndexedDB error:", event.target.error);
        reject("Error opening IndexedDB");
      };

      request.onsuccess = (event) => {
        resolve(event.target.result);
      };

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('studentData')) {
          db.createObjectStore('studentData', { keyPath: 'id' });
        }
      };
    });
  };


  const fetchTodaysBirthdays = async () => {
    try {
      const db = await openIndexedDB();
      const transaction = db.transaction(['studentData'], 'readonly');
      const objectStore = transaction.objectStore('studentData');
      const allRecords = objectStore.getAll();

      allRecords.onsuccess = (event) => {
        const data = event.target.result;
        if (data) {
        const today = new Date();
        const todayDayMonthString = `${today.getMonth() + 1}-${today.getDate()}`;
  
        const todayBirthdays = Object.values(data)
          .filter(student => student !== null)
          .filter(student => {
            const dob = new Date(student.dob);
            
            const dobDayMonthString = `${dob.getMonth() + 1}-${dob.getDate()}`;
            return dobDayMonthString === todayDayMonthString;
          });
  
        setTodaysBirthdays(todayBirthdays);
        }
        allRecords.onerror = (event) => {
          console.error('Error fetching student data from IndexedDB:', event.target.error);
        };
      }
      
    } catch (error) {
      console.error('Error fetching data:', error);
      setFetchError(error.message);
    }
  };
  

  useEffect(() => {
    fetchTodaysBirthdays();
  }, [udiseNumber]);

  const handleStudentClick = (student) => {
    const fullName = `${student.stdName} ${student.stdFather} ${student.stdSurname}`;
    if (selectedStudent === fullName) {
      setImageIndex(0);
    } else {
      setSelectedStudent(fullName);
      setImageIndex(0);
      setIsLoading(true); 
      const studentImages = [
        img,
        imgA,
        imgB,
        imgC,
        imgD,
        imgE,
        imgF,
        imgG,
        imgH,
        imgI,
      ];
      
      Promise.all(studentImages.map((image) => getBase64Image(image, fullName)))
        .then((imagesWithNames) => {
          setSelectedStudentImages(imagesWithNames);
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  };

  const handleNextImage = () => {
    setImageIndex((imageIndex + 1) % selectedStudentImages.length);
  };

  const handlePrevImage = () => {
    setImageIndex((imageIndex - 1 + selectedStudentImages.length) % selectedStudentImages.length);
  };

  const handleShareWhatsApp = async () => {
    try {
      const imageUrl = selectedStudentImages[imageIndex];
      const studentIndex = todaysBirthdays.findIndex(student => {
        const fullName = `${student.stdName} ${student.stdFather} ${student.stdSurname}`;
        return fullName === selectedStudent;
      });
      if (studentIndex !== -1) {
        const studentName = `${todaysBirthdays[studentIndex].stdName} ${todaysBirthdays[studentIndex].stdFather} ${todaysBirthdays[studentIndex].stdSurname}`;
        const base64Image = await getBase64Image(imageUrl, studentName);
        const blob = await fetch(base64Image).then(response => response.blob());
        const filesArray = [new File([blob], 'birthday_image.jpg', { type: blob.type })];
        if (navigator.canShare && navigator.canShare({ files: filesArray })) {
          navigator
            .share({
              files: filesArray,
              text: 'Birthday image',
              title: 'Birthday Image',
            })
            .then(() => {
            })
            .catch(error => {
              console.error('Error sharing image:', error);
            });
        } else {
          console.error('Sharing not supported');
        }
      } else {
        console.error('Student not found in today\'s birthdays');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };
    const [schoolData, setSchoolData] = useState(null);
    const fetchSchoolData = async () => {
      if (udiseNumber) {
        try {
          const db = await openIndexedDB();
          const transaction = db.transaction(['schoolData'], 'readonly');
          const objectStore = transaction.objectStore('schoolData');
          const request = objectStore.get(udiseNumber);
  
          request.onsuccess = (event) => {
            const data = event.target.result;
            if (data) {
              setSchoolData(data);
            }
          };
  
          request.onerror = (event) => {
            console.error("Error fetching school data:", event.target.error);
          };
        } catch (error) {
          console.error('Error fetching school data:', error);
        }
      }
    };
  
    useEffect(() => {
      fetchSchoolData ();
  }, [udiseNumber]);

  const getBase64Image = async (url, studentName) => {
    return new Promise(async (resolve, reject) => {
      const img = new Image();
      img.setAttribute('crossOrigin', 'anonymous');
      img.onload = async function () {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = this.width;
        canvas.height = this.height;
        ctx.drawImage(this, 0, 0);

        try {
          

          if (schoolData && schoolData.schoolName) {
            const schoolName = schoolData.schoolName;
            const MAX_CHARACTERS = 40;
            const FONT_SIZE = 45;
            const Y_POSITION = 1080;

            ctx.font = `bold ${FONT_SIZE}px Arial`;
            ctx.fillStyle = 'white';

            const x = canvas.width / 2;
            let y = Y_POSITION + FONT_SIZE + 10;
            let lines = [];
            let currentLine = '';

            for (let i = 0; i < schoolName.length; i++) {
              if (currentLine.length >= MAX_CHARACTERS) {
                lines.push(currentLine);
                currentLine = '';
              }

              if (schoolName[i] === ' ') {
                if (ctx.measureText(currentLine + ' ' + schoolName.slice(i + 1).split(' ')[0]).width > canvas.width) {
                  lines.push(currentLine);
                  currentLine = '';
                }
              }
              currentLine += schoolName[i];
            }

            lines.push(currentLine);

            lines.forEach((line, index) => {
              const textWidth = ctx.measureText(line).width;
              const lineY = y + (index * (FONT_SIZE + 10));
              const lineX = x - textWidth / 2;
              ctx.fillText(line, lineX, lineY);
            });

            ctx.font = 'bold 80px Arial';
            ctx.fillStyle = 'white';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            const textX = canvas.width / 2;
            const textY = 320; 
            ctx.fillText(studentName, textX, textY);

            const dataURL = canvas.toDataURL('image/jpeg');
            resolve(dataURL);
          } else {
            reject(new Error('School data not available'));
          }
        } catch (error) {
          reject(new Error('Failed to process image'));
        }
      };
      img.onerror = function () {
        console.error('Image load error', url);
        reject(new Error('Could not load image'));
      };
      img.src = url;
    });
  };

  
  const shapeStyle = {
    position: 'absolute',
    width: '100px',
    height: '100px',
    opacity: 0.5,
    borderRadius: '50%',
    animation: 'float 6s ease-in-out infinite'
  };

  const shape1Style = {
    ...shapeStyle,
    top: '90%',
    left: '10%',
    background: '#ff6b6b',
    animationDelay: '0s'
  };

  const shape2Style = {
    ...shapeStyle,
    top: '90%',
    left: '30%',
    background: '#ffd93b',
    animationDelay: '2s'
  };

  const shape3Style = {
    ...shapeStyle,
    top: '90%',
    left: '50%',
    background: '#6bcfff',
    animationDelay: '4s'
  };

  const shape4Style = {
    ...shapeStyle,
    top: '90%',
    left: '70%',
    background: '#92D050',
    animationDelay: '1s'
  };

  const shape5Style = {
    ...shapeStyle,
    top: '90%',
    left: '90%',
    background: '#7030A0',
    animationDelay: '3s'
  };


  return (
    <div>
{/* <Sidebar/> */}
    
    <div style={{ position: 'relative',  height:'90vh',    backgroundRepeat: 'no-repeat', backgroundPosition: 'center'  }} className='main-content-of-page'>

       
      {selectedStudent && (
  <div className="selected-student-images" style={{ paddingTop: '80px', textAlign: 'center', position: 'relative', marginBottom:'150px' }}>
  <style>
        {`
          @keyframes float {
            0% { transform: translateY(0); }
            50% { transform: translateY(-990px); }
            100% { transform: translateY(0); }
          }
        `}
      </style>
      <div style={shape1Style}></div>
      <div style={shape2Style}></div>
      <div style={shape3Style}></div>
      <div style={shape4Style}></div>
      <div style={shape5Style}></div>
    <button 
      onClick={() => setSelectedStudent(null)} 
      style={{ 
        position: 'absolute', 
        top: '20px', 
        right: '20px', 
        color: 'red', 
        border: 'none', 
        borderRadius: '50%', 
        cursor: 'pointer', 
        height: '30px', 
        width: '30px', 
        fontSize: '35px', 
        display: 'flex', 
        alignItems: 'center', backgroundColor:'transparent',
        justifyContent: 'center', paddingTop:'2px'
      }}
    >
      <i className="fa-regular fa-circle-xmark" style={{ fontWeight:'bolder'}}></i>
    </button>
    
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <FontAwesomeIcon icon={faArrowLeft} onClick={handlePrevImage} style={{ cursor: 'pointer', marginRight: '10px' }} />
      <img src={selectedStudentImages[imageIndex]} alt="Birthday" style={{ width: '500px', height: '500px', objectFit: 'cover' }} />
      <div className="loading-animation">
        {isLoading && (
          <img src={spinner} alt="Loading animation" />
        )}
      </div>
      <FontAwesomeIcon icon={faArrowRight} onClick={handleNextImage} style={{ cursor: 'pointer', marginLeft: '10px' }} />
    </div>
    
    <button onClick={handleShareWhatsApp} style={{margin:'auto', marginTop: '30px', padding: '10px 10px', background: '#25D366', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', display: 'flex', alignItems: 'center',  justifyContent: 'center'}}>
      <WhatsappIcon size={24} /> Share on WhatsApp
    </button>
  </div>
)}
      <SchoolDataCard/>
    </div>

    </div>
  );
};

export default Home;

